export enum LOGGED {
  IN = 'logged_in',
  OUT = 'logged_out',
}
